import AboutMe from "../AboutMe";
import ContactMe from "../ContactMe";
import Footer from "../Footer";
import HeroSection from "../HeroSection";
import MyPortfolio from "../Portfolio/Portfolio";
import Apps from "../../Apps/Apps";
import MySkills from "../MySkills";
import Testimonial from "../Testimonials";
import Portfolio from "../Portfolio/Portfolio";

export default function Home() {
  return (
    <>
      <HeroSection />
      <MySkills />
      <AboutMe />
      <Portfolio />
      <Apps />
      
      {/* <Testimonial /> */}
      <Footer />
    </>
  );
}
